import React from 'react'

const NotFound = () => {
  return (
    <h1 className="sm:text-4xl text-2xl font-bold mt-6 text-gray-900">
    404: Page Not Found
    </h1>
  )
}

export default NotFound


